<template>
  <div id="map-main" class="map-main">
    <div id="stage" class="stage">
      <div class="leftplane">
        <div class="left-menu">
          <div class="toolbar">
            <div
              class="ai-button ai-button--clear actions__button left-button"
              @click="backgroundMap"
            >
              参考图
            </div>
            <div
              class="ai-button ai-button--clear actions__button left-button"
              @click="addList"
            >
              新增
            </div>
            <div
              class="ai-button ai-button--clear actions__button left-button"
              @click="editImage"
            >
              裁剪
            </div>
            <div
              class="ai-button ai-button--clear actions__button left-button"
              @click="rollRight"
            >
              顺转
            </div>
            <div
              class="ai-button ai-button--clear actions__button left-button"
              @click="rollLeft"
            >
              逆转
            </div>
            <div
              class="ai-button ai-button--clear actions__button left-button"
              @click="DelList"
            >
              删除
            </div>
            <div class="blockbox">
              <div class="block">
                <el-slider v-model="scaleValue" :min="20"></el-slider>
              </div>
            </div>
          </div>
          <div class="helpbox">
            <div class="help">
              <img
                @mouseout="onOutTip()"
                @mouseover="onShowTip()"
                src="@/assets/views/map/help.png"
              />
            </div>
            <div class="tip" v-show="showTip">
              <img src="@/assets/views/map/123.png"/>
            </div>
          </div>
          <input
            v-show="!!0"
            ref="uploader"
            type="file"
            class="upload__input"
            accept="image/*"
            @change="getImageFile"
          />
        </div>
        <div id="mapplane" class="mapplane" @mousewheel.prevent>
          <canvas id="pixi"></canvas>
        </div>
      </div>
      <div class="right-plane">
        <div class="right-title">图层列表</div>
        <div class="borderline"></div>
        <div class="right-list">
          <el-scrollbar
            style="height: 92%"
            :native="false"
            class="elp"
          >
            <div class="list">
              <draggable
                class="list-group"
                v-model="list"
                v-bind="dragOptions"
                @change="onListChange"
                :move="onMove"
                @start="isDragging = true"
                @end="isDragging = false"
              >
                <transition-group type="transition" :name="'flip-list'">
                  <div
                    :class="
                      !element.selected
                        ? 'list-group-item'
                        : 'list-group-item-selected'
                    "
                    v-for="element in list"
                    :key="element.id"
                    @click="onClickItem(element)"
                    :title="element.name"
                  >
                    <div class="itemrow">
                      <span
                        :class="element.status == 0 ? 'badge' : 'badge-green'"
                      ></span>
                      <el-button
                        type="text"
                        @click.stop="handleToggleLock(element)"
                        :style="{color: element.canSelect ? 'green' : 'red' }"
                      >
                        {{ element.canSelect === false ? '已锁定' : '已解锁' }}
                      </el-button>
                      <i
                        :class="
                          element.fixed
                            ? 'fa fa-anchor'
                            : 'glyphicon glyphicon-pushpin'
                        "
                        @click="item.fixed = !item.fixed"
                        aria-hidden="true"
                      ></i>
                      {{ CharText(element.name) }}
                    </div>
                    <div class="movetip"><br />..<br />..<br />..</div>
                  </div>
                </transition-group>
              </draggable>
            </div>
          </el-scrollbar>
          <div class="borderline"></div>
          <div class="right-bottom">
            <div
              style="margin-left: 20px; width: 35%"
              class="ai-button ai-button--primary listbtn"
              @click="saveVRMap"
            >
              保存
            </div>
            <div
              style="width: 35%"
              class="ai-button listbtn"
              :class="{
                'ai-button--disabled': proudceing,
                'ai-button--primary': !proudceing
              }"
              @click="produceVR"
            >
              生成VR
            </div>
          </div>
        </div>
      </div>

      <AiDialog
        class="progress-dialog"
        width="441"
        :visible.sync="addUIvisible"
        @close="closeAddDialog"
      >
        <div slot="header" class="dialog__header">绑定VR ID</div>

        <div class="create-sub-dialog__creatARcontent">
          <div style="padding: 20px">
            <b>VR ID</b>
            <el-input
              v-model="VRIDinput"
              placeholder="请输入VR ID"
              style="margin-top: 20px"
              @change="onInput"
              @keyup.enter.native="onInput"
            />
          </div>
        </div>
        <div slot="footer" class="dialog__footer">
          <div
            style="margin-left: 20px; width: 60px"
            class="ai-button ai-button--primary"
            @click="getVRMap"
          >
            确 定
          </div>
          <div
            style="margin-left: 20px; width: 60px"
            class="ai-button"
            @click="closeAddDialog"
          >
            取 消
          </div>
        </div>
      </AiDialog>
    </div>
    <EditPlane
      ref="editplane"
      v-show="editPlaneVisible"
      :item-data="nowSeletedItem"
      @close="closeEditDialog"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import * as PIXI from 'pixi.js';

import draggable from 'vuedraggable';
import { BlurFilter } from '@pixi/filter-blur';
import { Container } from '@pixi/display';
import { Graphics } from '@pixi/graphics';
import { Sprite } from '@pixi/sprite';
import { Point, Loader } from 'pixi.js';
import { Matrix } from 'pixi.js';
import SparkMD5 from 'spark-md5';

import { Vector2 } from 'three';

import MapClip from './js/clip';
import { Loading } from 'element-ui';

const ICON_EDIT = require('@/assets/views/map/ROLL.png');

export default {
  components: {
    draggable,
  },
  name: 'ConnectionsLayer',
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
  },
  data() {
    return {
      proudceing: false,
      mapParams: { nowScale: 1, scale: 1, orgwidth: 800 },
      list: [],
      editable: true,
      isDragging: false,
      delayedDragging: false,
      nowSeletedItem: null,
      app: null,
      editPlaneVisible: false,
      currentEditItem: null,
      //  nowediteData:null,
      addUIvisible: false,
      VRIDinput: '',
      mapCavans: null,
      bgSprite: null,
      scaleValue: 100,
      mousedata: {
        down: false,
        moveing: false,
        d_x: null,
        d_y: null,
        over: false,
        rootmoving: false,
      },
      keyPress: { downCode: 0 },
      showTip: false,
      groundData: { cmap: '', width: 0, height: 0 },
      allCenter: null,
      rollSprite: null,
      rollStauts: {
        vector: new Vector2(0, 0),
        down: false,
        moveing: false,
        d_x: null,
        d_y: null,
        over: false,
      },
      mapClipVisible: false
    };
  },
  methods: {
    handleToggleLock(element) {
      element.canSelect = !element.canSelect;

      if (element.mapClip) {
        element.mapClip.interactive = element.canSelect;
        if (element.transform) {
          element.transform.canSelect = element.canSelect;
        }
        element.mapClip.SaveData();
      }

      if (element.canSelect === false && element.selected) {
        element.selected = false;
        if (element.mapClip) {
          element.mapClip.onSelected(false);
        }
        if (this.nowSeletedItem && this.nowSeletedItem.id === element.id) {
          this.nowSeletedItem = null;
          this.showSeleted(null);
        }
      }
    },
    onResize() {

      const stage = document.getElementById('mapplane');
      if (!stage || !this.app) return;

      const width = stage.clientWidth;
      const height = stage.clientHeight;

      this.app.renderer.resize(width, height);
    },
    // ---------------------------------------------------------上传相关---------------------
    getImageFile() {
      const file = this.$refs.uploader.files[0];
      const fileSize = file.size; // 文件大小
      const chunkSize = 1024 * 1024 * 10; // 切片的大小
      const chunks = Math.ceil(fileSize / chunkSize); // 获取切片个数
      const fileReader = new FileReader();
      const spark = new SparkMD5.ArrayBuffer();
      const bolbSlice = File.prototype.slice
        || File.prototype.mozSlice
        || File.prototype.webkitSlice;
      let currentChunk = 0;
      fileReader.onload = (e) => {
        const res = e.target.result;
        spark.append(res);
        currentChunk++;
        if (currentChunk < chunks) {
          loadNext();
          console.log(`第${currentChunk}分片解析完成, 开始第${currentChunk + 1}分片解析`);
        } else {
          const md5 = spark.end();
          console.log('解析完成');
          this.upload(md5, file, file.name.split('.')[1]);
        }
      };
      const loadNext = () => {
        const start = currentChunk * chunkSize;
        const end = start + chunkSize > file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(bolbSlice.call(file, start, end));
      };
      loadNext();
    },

    upload(md5, file, filetype) {
      this.$refs.uploader.value = null;
      console.log(md5);
      // this.loadingUIVisible = true;

      return new Promise((resolve, reject) => {
        // eslint-disable-next-line
        this.$http
          .post(
            `https://vrapi.aibee.cn/mesh/cmap/upload?md5=${md5}&filetype=${filetype}`,
            file,
            {
              headers: { 'Content-Type': 'text/plain' },
              onUploadProgress: (progressEvent) => {
                const complete = `${((progressEvent.loaded / progressEvent.total) * 100) | 0
                  }%`;
                // this.uploadprogress = (progressEvent.loaded / progressEvent.total * 100 | 0);
                console.log(`上传 ${complete}`);
              },
            }
          )
          .then(async (response) => {
            // console.log(response.data.data.filename);
            //  console.log(response.data.data[0].filename,'this.uploadType: ',this.uploadType);
            this.reDrawBackGround(response.data.data.filename, 1);
            resolve(response.data);
          })
          .catch((error) => {
            console.log('错误错误！！！', error);
            reject(error);
          });
      });
    },
    onShowTip() {
      this.showTip = true;
    },
    onOutTip() {
      this.showTip = false;
    },
    async modifyCmap() {
      const pamras = {
        merge_id: this.$route.query.merge_id,
        cmap: this.groundData.cmap,
        width: this.groundData.width,
        height: this.groundData.height,
      };
      const str = '/mesh/cmap/modify';
      const {
        data: { data },
      } = await this.$http.post(str, pamras);
    },
    // ---------------------------------------------------------上传相关
    CharText(str) {
      if (str.length > 12) {
        str = str.slice(0, 12);
        str += '...';
      }
      return str;
    },
    async getVRMap() {
      this.addUIvisible = false;
      // Ihf1UwV4gfD5hCgo
      // this.VRIDinput = 'Ihf1UwV4gfD5hCgo';

      // 检查是否又重复

      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].vr_id === this.VRIDinput) {
          this.$message.basic('添加的 VRID 已经存在！');
          return;
        }
      }

      const pamras = { vr_id: this.VRIDinput };
      const str = '/mesh/plymap/list';
      const {
        data: { data },
      } = await this.$http.post(str, pamras);

      //  let  data =
      //         {
      //             name: "武汉汉口K11：L35地图",
      //             plymap: "https://robot-vr-public.cdn.bcebos.com/6eaa2fd22f2749bda5336a8f056b853e/1611897655.png",
      //             params: {
      //                 scale: 20.0,
      //                 theta: 0.0,
      //                 x_ratio: 0.5033359888800636,
      //                 y_ratio: 0.480460651310564
      //             }
      //         }

      //     console.log('------data--------------------',data);
      if (data) {
        data.id = this.list.length;
        console.log('------data.id--------------------', data.id);
        data.vr_id = this.VRIDinput;
        data.status = 0;
        data.canSelect = true;
        data.selected = true;
        // this.list.push(data);
        this.list.unshift(data);
        this.onClickItem(data);
        await this.addMapClip(data);

        // this.onClickItem(data);
        this.editPlaneVisible = true;
        this.$refs.editplane.show();
      }
    },
    onInput() { },
    closeAddDialog() {
      this.addUIvisible = false;
    },
    DelList() {
      // console.log('删除当前',this.nowSeletedItem);

      this.$confirm({
        title: '确认要删除模型吗?',
        message: '删除后无法裁切数据，只能重新导入!',
      })
        .then(async () => {
          try {
            if (this.nowSeletedItem !== null) {
              for (var i = 0; i < this.list.length; i++) {
                if (
                  this.list[i].mapClip != null
                  && this.list[i].id !== this.nowSeletedItem.id
                ) {
                  this.list[i].mapClip.onSelected(false);
                }
                if (this.list[i].id == this.nowSeletedItem.id) {
                  this.mapCavans.removeChild(this.list[i].mapClip);
                  this.list.splice(
                    this.list.findIndex(e => e.id === this.list[i].id),
                    1
                  );
                }
              }
            }
          } catch (error) {
            this.$message.basic(error.error_msg);
          }
        })
        .catch(() => { });
    },
    addList() {
      this.addUIvisible = true;
      // this.list.push({id:this.list.length,name:'asd',fixed: false,selected:false});
    },
    onClickItem(item) {
      if (item == null) return;
      if (item.canSelect === false) return;

      if (this.nowSeletedItem === item && item.selected) {
        return;
      }

      if (this.nowSeletedItem !== null) {
        this.nowSeletedItem.selected = false;
      }

      item.selected = true;
      this.nowSeletedItem = item;

      if (this.nowSeletedItem !== null) {
        for (let i = 0; i < this.list.length; i++) {
          const listItem = this.list[i];
          if (
            listItem.mapClip != null
            && listItem !== this.nowSeletedItem
          ) {
            listItem.mapClip.onSelected(false);
            listItem.selected = false;
          }
        }
      }

      if (item.mapClip != null) {
        item.mapClip.onSelected(true);

        this.showSeleted(item.mapClip);

        if (item.mapClip.alpha != 0) {
          this.scaleValue = item.mapClip.alpha * 100;
        } else this.scaleValue = 100;
      }

      //  console.log('选中了:',item.id,item.selected);

      //  item.fixed=! item.fixed
    },
    showSeleted(mapClip) {
      if (this.allCenter == null) {
        this.allCenter = new Graphics();
        this.mapCavans.addChild(this.allCenter);
      }

      this.allCenter.clear();
      if (this.rollSprite) {
        this.rollSprite.visible = (mapClip != null);
      }
      if (mapClip == null) return;

      if (mapClip.boundBoxPoint == null) return;

      if (this.rollSprite == null) {
        this.rollSprite = Sprite.from(ICON_EDIT);
        this.rollSprite.width = 5;
        this.rollSprite.height = 5;

        this.rollSprite.anchor.set(0.5);

        this.rollSprite.interactive = true;
        this.mapCavans.addChild(this.rollSprite);

        this.rollSprite.on('mousedown', (event) => {
          this.rollStauts.down = true;

          event.stopPropagation();

          this.rollStauts.vector = new Vector2(
            event.data.global.x,
            event.data.global.y
          );
          this.rollStauts.d_x = event.data.global.x;
          this.rollStauts.d_y = event.data.global.y;
        });

        document.addEventListener('mouseup', (e) => {
          this.rollStauts.down = false;
          // 取消当前选择

          if (this.mousedata.rootmoving) {
            this.nowSeletedItem.selected = false;
            if (this.nowSeletedItem.mapClip) {
              this.nowSeletedItem.mapClip.releaseSelected();
            }
          }
          this.mousedata.rootmoving = false;
        });

        document.addEventListener('mousemove', (e) => {
          // this.mousedata.rootmoving = true;
        });

        this.rollSprite.on('mousemove', (event) => {
          if (this.rollStauts.down) {
            const bounds = this.nowSeletedItem.mapClip.boundBox.getBounds();
            const centerX = bounds.x + bounds.width / 2;
            const centerY = bounds.y + bounds.height / 2;
            const angle = Math.atan2(event.data.global.x - centerX, event.data.global.y - centerY) * 180 / Math.PI;
            const angle1 = Math.atan(this.nowSeletedItem.mapClip.boundBoxRect.height / this.nowSeletedItem.mapClip.boundBoxRect.width) * 180 / Math.PI;
            this.nowSeletedItem.mapClip.setRotation2(-angle + 90 + angle1);
          }
        });
      }

      let local = this.mapCavans.toLocal(
        new Point(mapClip.boundBoxPoint[0].x, mapClip.boundBoxPoint[0].y),
        mapClip
      );
      this.allCenter.lineStyle(1, 0x00ff00);
      this.allCenter.moveTo(local.x, local.y);
      for (let i = 0; i < mapClip.boundBoxPoint.length; i++) {
        local = this.mapCavans.toLocal(
          new Point(mapClip.boundBoxPoint[i].x, mapClip.boundBoxPoint[i].y),
          mapClip
        );
        this.allCenter.lineTo(local.x, local.y);
        if (i == 1) {
          this.rollSprite.scale.x = mapClip.scale.x * 0.5;
          this.rollSprite.scale.y = mapClip.scale.y * 0.5;

          local = this.mapCavans.toLocal(
            new Point(
              mapClip.boundBoxPoint[i].x + this.rollSprite.width / 2,
              mapClip.boundBoxPoint[i].y - this.rollSprite.width / 2
            ),
            mapClip
          );
          this.rollSprite.x = local.x;
          this.rollSprite.y = local.y;
        }
      }
      local = this.mapCavans.toLocal(
        new Point(mapClip.boundBoxPoint[0].x, mapClip.boundBoxPoint[0].y),
        mapClip
      );
      this.allCenter.lineTo(local.x, local.y);

      // local= this.mapCavans.toLocal( new Point(mapClip.boundBoxPoint[1].x,mapClip.boundBoxPoint[1].y -50/2),mapClip);
      // let local0= this.mapCavans.toLocal( new Point(mapClip.boundBoxPoint[0].x,mapClip.boundBoxPoint[0].y - 50),mapClip);
      // this.rollSprite.x = local0.x-(local0.x-local.x)/2  -25 /2;
      // this.rollSprite.y = local0.y-(local0.y-local.y)/2 -25 /2;
    },
    onListChange(e) {
      if (e.moved) {
        // console.log('从：'+e.moved.oldIndex +'移动到'+e.moved.newIndex);

        for (let i = 0; i < this.list.length; i++) {
          // this.list[i].id = i;
          // this.mapCavans.setChildIndex(this.list[i].mapClip, i+1);
          this.mapCavans.setChildIndex(
            this.list[i].mapClip,
            this.list.length - i
          );
        }
      }
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
    },
    closeEditDialog() {
      // ----save
      this.editPlaneVisible = false;

      // ---redraw
      this.reDrawMc();

      this.onClickItem(this.nowSeletedItem);
    },
    reDrawMc() {
      this.mapCavans.removeChild(this.nowSeletedItem.mapClip);
      this.nowSeletedItem.mapClip = new MapClip(this);
      this.nowSeletedItem.mapClip.initMap(this.nowSeletedItem);
      this.mapCavans.addChild(this.nowSeletedItem.mapClip);

      for (let i = 0; i < this.list.length; i++) {
        // this.list[i].id = i;
        console.log('reDraw id : ', this.list[i].id);
        this.mapCavans.setChildIndex(
          this.list[i].mapClip,
          this.list.length - i
        );
      }
    },
    async addMapClip(data) {
      this.nowSeletedItem.mapClip = new MapClip(this);
      data.plymap = data.plymap.replace('https://robot-vr.aibee.cn', '')
      console.log(data);
      await this.nowSeletedItem.mapClip.initMap(data);
      this.mapCavans.addChild(this.nowSeletedItem.mapClip);
      // this.nowSeletedItem.mapClip.visible = false
      this.currentEditItem = this.nowSeletedItem.mapClip;

      for (let i = 0; i < this.list.length; i++) {
        // this.list[i].id = i;
        this.mapCavans.setChildIndex(this.list[i].mapClip, this.list.length - i);
      }

      // console.log(this.mapCavans.children.length)
    },
    backgroundMap() {
      if (this.groundData.cmap !== '') {
        this.$confirm({
          title: '确认要更换参考图吗?',
          message: '更换参考图可能需要重新调整对齐!',
        })
          .then(async () => {
            try {
              this.$refs.uploader.click();
            } catch (error) {
              this.$message.basic(error.error_msg);
            }
          })
          .catch(() => { });
      } else {
        try {
          this.$refs.uploader.click();
        } catch (error) {
          this.$message.basic(error.error_msg);
        }
      }
    },
    async getMergeData() {
      const params = { merge_id: this.$route.query.merge_id };

      const str = '/mesh/merge/data';
      const {
        data: { data },
      } = await this.$http.post(str, params);
      if (data) {
        data.mesh && data.mesh.reverse();
        this.reLoadData(data);
      }
    },
    async reLoadData(data) {
      this.list = [];
      if (this.mapCavans) {
        for (let i = this.mapCavans.children.length - 1; i >= 0; i--) {
          const child = this.mapCavans.children[i];
          if (child instanceof MapClip || child.typeName === 'MapClip') {
            this.mapCavans.removeChild(child);
          }
        }
      }

      if (data.mesh && data.mesh.length > 0) {
        const master = data.mesh.find(m => m.index === 0) || data.mesh[0];
        if (master && master.params) {
          this.mapParams = {
            ...master.params,
            nowScale: (master.transform && master.transform.a) || 1,
            orgwidth: (master.transform && master.transform.selfWidth) || 800
          };
        }
      }

      await this.reDrawBackGround(data.cmap);

      const loadingInstance = Loading.service({
        fullscreen: true,
        text: '加载中',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      const { length } = data.mesh;
      // 最大栅格图开启图形优化
      if (length > 30) {
        // this.mapClipVisible = true
      }
      let lastItem = null;
      for (let i = 0; i < length; i++) {
        var item = {};
        if (data.mesh.length == 0) return;
        item.vr_id = data.mesh[i].vr_id;
        item.pointArg = [];
        // console.log('----',data.mesh[i]);
        if (data.mesh[i].transform.pointArg == null) {
          item.pointArg = [];
        } else {
          const rawPointArg = data.mesh[i].transform.pointArg;
          if (rawPointArg.length > 0 && !(rawPointArg[0] instanceof Array) && rawPointArg[0].x !== undefined) {
             item.pointArg = [rawPointArg.map(p => new Point(p.x, p.y))];
          } else {
             item.pointArg = rawPointArg.map(group => group.map(p => new Point(p.x, p.y)));
          }
        }

        item.polygon = data.mesh[i].polygon;
        if (item.polygon == null) item.polygon = [];
        if (item.polygon.length > 0 && !(item.polygon[0][0] instanceof Array)) {
           item.polygon = [item.polygon];
        }

        let ratio = 1;
        const transform = data.mesh[i].transform;
        item.transform = transform;
        if (transform && transform.bgHeight && this.bgSprite && this.bgSprite.height) {
          ratio = this.bgSprite.height / transform.bgHeight;
        }

        item.pos = new Point(
          transform.pox * ratio,
          transform.poy * ratio
        );
        item.matrix = new Matrix(
          transform.a * ratio,
          transform.b * ratio,
          transform.c * ratio,
          transform.d * ratio,
          transform.tx * ratio,
          transform.ty * ratio
        );

        item.name = data.mesh[i].name;
        item.plymap = data.mesh[i].plymap;
        item.id = data.mesh[i].index !== undefined ? data.mesh[i].index : i;
        item.selected = true;
        item.canSelect = data.mesh[i].transform.canSelect === undefined ? true : data.mesh[i].transform.canSelect;
        item.params = data.mesh[i].params;
        item.anchor = new Point(
          data.mesh[i].transform.anchorx,
          data.mesh[i].transform.anchory
        );
        item.alpha = data.mesh[i].transform.alpha;
        this.list.push(item);
        this.nowSeletedItem = item;
        this.nowSeletedItem.selected = false;
        // this.onClickItem(item);
        await this.addMapClip(item);
        item.mapClip.onSelected(false);
        lastItem = item;
      }
      console.log('加载完成');
      loadingInstance.close();

      //  for(var i =0;i<data.mesh.length;i++)
      //  {

      //  }

      console.log('---------------', this.list);
    },
    async saveVRMap() {
      console.log('保存数据');
      // {
      //     "merge_id": "lnoBX7kKPi3H0ZKn",
      //     "mesh": [
      //         {
      //             "vr_id": "nOdF1v13WFakKcQc",
      //             "polygon": [[[1289, 2052], [2695, 2092], [3147, 1750]]],
      //             "transform": [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
      //             "pos":[233.1,13.44]
      //         },
      //         {
      //             "vr_id": "tLV7MP71GWegcUKg",
      //             "polygon": [[[1289, 2052], [2695, 2092], [3147, 1750]], [[1300, 1472], [1212, 2072], [2300, 1608]]],
      //             "transform": [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      //         }
      //     ]
      // }
      const params = { merge_id: this.$route.query.merge_id, mesh: [] };
      // this.list.forEach(element => {
      //     params.mesh.push(
      //       {
      //         vr_id:element.vr_id,
      //         polygon:[element.polygon],
      //         transform:element.transform,
      //         // pos:[element.pos.x,element.pos.y]
      //       }
      //     )
      // });
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        if (item.mapClip) {
          item.mapClip.SaveData();
        }
      }
      for (let i = this.list.length - 1; i >= 0; i--) {
        const item = this.list[i];
        params.mesh.push({
          vr_id: item.vr_id,
          polygon: item.polygon,
          transform: item.transform,
        });
      }

      const str = '/mesh/merge/save';
      const {
        data: { data },
      } = await this.$http.post(str, params);
      if (data) {
        this.$message.basic({
          message: '保存数据成功',
        });
      }
    },
    async produceVR() {
      this.proudceing = true;

      const str = '/mesh/merge/task';
      const params = { merge_id: this.$route.query.merge_id };
      const {
        data: { data },
      } = await this.$http.post(str, params);
      if (data) {
        this.$message.basic({
          message: '生成数据中.....',
        });
        // this.proudceing = true;
      }
    },

    rollLeft() {
      this.nowSeletedItem.mapClip.setRotation(-1);
    },
    rollRight() {
      this.nowSeletedItem.mapClip.setRotation(1);
    },
    removeList() {
      // this.$refs.editplane.show();
      // this.editPlaneVisible = !this.editPlaneVisible;
    },
    editImage() {
      this.editPlaneVisible = true;
      this.$refs.editplane.show();
    },
    async reDrawBackGround(url, upload) {
      const p = new Promise((resolve) => {
        if (this.bgSprite !== null) {
          const index = this.mapCavans.getChildIndex(this.bgSprite);
          // let index = this.app.stage.getChildIndex(this.bgSprite);
          if (index !== -1) {
            this.mapCavans.removeChild(this.bgSprite);
            //  this.app.stage.removeChild(this.bgSprite);
          }
        }

        // this.bgSprite = Sprite.from(url);

        const loader = new Loader();

        loader.add('bgMap', url);

        loader.load((loader, resources) => {
          this.bgSprite = new Sprite(resources.bgMap.texture);
          const stage = document.getElementById('mapplane');

          // console.log(this.bgSprite.width,stage.clientWidth);
          // console.log(this.bgSprite.height,stage.clientHeight);
          console.log(url);
          this.groundData.cmap = url;
          this.groundData.width = this.bgSprite.width;
          this.groundData.height = this.bgSprite.height;

          this.bgSprite.width = (this.bgSprite.width * stage.clientHeight) / this.bgSprite.height;
          this.bgSprite.height = stage.clientHeight;

          if (upload) {
            this.modifyCmap();
          }

          this.mapCavans.addChild(this.bgSprite);

          this.mapCavans.pivot.set(
            this.mapCavans.width / 2,
            this.mapCavans.height / 2
          );
          console.log(
            'this.mapCavans: width',
            this.mapCavans.width,
            this.mapCavans.height
          );
          console.log(
            'this.mapCavans: piovt',
            this.mapCavans.pivot.x,
            this.mapCavans.pivot.y
          );

          this.mapCavans.x = this.mapCavans.width / 2;
          this.mapCavans.y = this.mapCavans.height / 2;

          this.setMouseEvent();
          resolve();
        });
      });
      return p;
    },
    setMouseEvent() {
      console.log('setMouseEvent-log')
      this.mapCavans.interactive = true;
      this.mapCavans.on('mousedown', (event) => {
        this.pointerdown = true
        this.mousedata.down = true;
        this.mousedata.moveing = true;
        this.mousedata.d_x = event.data.global.x;
        this.mousedata.d_y = event.data.global.y;
      });

      this.mapCavans.on('mouseup', (event) => {
        this.pointerdown = false
        if (this.mapClipVisible) {
          if (this.mouseTimer) {
            clearTimeout(this.mouseTimer)
            this.mouseTimer = null
          }
          this.mouseTimer = setTimeout(() => {
            this.list.forEach(e => {
              if (!e.selected) {
                e.mapClip.visible = true
              }
            })
          }, 500)
        }
        this.mousedata.down = false;
        if (this.rollStauts.down) this.rollStauts.down = false;
        // console.log(this.mousedata.down);
        this.mousedata.moveing = false;
      });

      this.mapCavans.on('mouseover', (event) => {
        this.mousedata.over = true;
      });

      this.mapCavans.on('mouseupoutside', (event) => {
        this.mousedata.over = false;
      });
      this.mapCavans.on('mousemove', (event) => {
        if (!this.pointerdown) return
        if (this.mapClipVisible) {
          this.list.forEach(e => {
            if (!e.selected) {
              e.mapClip.visible = false
            }
          })
        }
        if (this.keyPress.downCode == 32 && this.mousedata.down) {
          // 全部模型移动
          const dx = event.data.global.x - this.mousedata.d_x;
          const dy = event.data.global.y - this.mousedata.d_y;
          // this.bgSprite.x+=dx;
          // this.bgSprite.y+=dy;

          this.list.forEach((element) => {
            element.mapClip.setMove(dx, dy);
          });

          this.mousedata.d_x = event.data.global.x;
          this.mousedata.d_y = event.data.global.y;
        }
        if (this.keyPress.downCode != 0) {
          return;
        }
        if (this.mousedata.down) {
          // 移动全部
          this.mousedata.moveing = true;
          const dx = event.data.global.x - this.mousedata.d_x;
          const dy = event.data.global.y - this.mousedata.d_y;
          this.mapCavans.x += dx;
          this.mapCavans.y += dy;

          this.mousedata.d_x = event.data.global.x;
          this.mousedata.d_y = event.data.global.y;
        }
      });
    },
    allChangedScale(value) {
      // if(this.allCenter==null)
      // {
      //   this.allCenter = new Graphics();
      //   this.mapCavans.addChild(this.allCenter);
      // }

      // this.allCenter.clear();
      const arglx = [];
      const argly = [];
      const argrx = [];
      const argry = [];
      this.list.forEach((element) => {
        // this.allCenter.beginFill(0xFF0000,0.2)
        this.allCenter.lineStyle(2, 0x00ff00);
        var rect = element.mapClip.getBounds(true, rect);
        const local = this.mapCavans.toLocal(new Point(rect.x, rect.y));

        const anchorPx = local.x + rect.width / this.mapCavans.transform.localTransform.a / 2;
        const anchorPy = local.y + rect.height / this.mapCavans.transform.localTransform.a / 2;

        // this.allCenter.drawCircle(anchorPx,anchorPy,5);
        // this.allCenter.drawRect(local.x,local.y,rect.width/this.mapCavans.transform.localTransform.a,rect.height/this.mapCavans.transform.localTransform.a);
        // this.allCenter.endFill();

        arglx.push(local.x);
        argly.push(local.y);
        argrx.push(local.x + rect.width / this.mapCavans.transform.localTransform.a);
        argry.push(local.y + rect.height / this.mapCavans.transform.localTransform.a);
      });

      const minx = Math.min(...arglx);
      const miny = Math.min(...argly);
      const minw = Math.max(...argrx);
      const minh = Math.max(...argry);

      // this.allCenter.beginFill(0xFF0000,0.1)
      // this.allCenter.lineStyle(2,0x00ff00)

      const anchorPx = minx + (minw - minx) / 2;
      const anchorPy = miny + (minh - miny) / 2;

      // this.allCenter.drawCircle(anchorPx,anchorPy,5);
      // this.allCenter.drawRect(minx,miny,minw-minx,minh-miny);
      // this.allCenter.endFill();

      this.list.forEach((element) => {
        element.mapClip.changedScale(value, anchorPx, anchorPy);
      });
    },
  },
  watch: {
    scaleValue(value) {
      // console.log(value);
      if (value <= 20) {
        value = 20;
        this.scaleValue = 20;
      }
      this.nowSeletedItem.mapClip.setAlpha(value / 100);
    },
    list(value) {
      // console.log(value);
    },
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
  },
  mounted() {
    // console.log('：',this.$route.query.merge_id);

    const stage = document.getElementById('mapplane');
    const canvas = document.getElementById('pixi');

    this.app = new PIXI.Application({
      width: stage.clientWidth,
      height: stage.clientHeight,
      antialias: true,
      transparent: true,
      view: canvas,
    });

    this.mapCavans = new Container();
    this.mapCavans.width = stage.clientWidth;
    this.mapCavans.height = stage.clientHeight;

    this.app.stage.addChild(new Graphics()
      .beginFill(0x999999)
      .drawRect(0, 0, stage.clientWidth * 100, stage.clientHeight * 100)
      .endFill());

    this.app.stage.addChild(this.mapCavans);

    this.getMergeData();

    // this.reDrawBackGround('https://robot-vr-public.cdn.bcebos.com/mesh_cmaps/846fbd/846fbd89e76a9cd598f46ae814ae4b14.svg');

    window.addEventListener(
      'keydown',
      (event) => {
        // console.log(event.keyCode);
        this.keyPress.downCode = event.keyCode;

        if (this.nowSeletedItem && this.nowSeletedItem.mapClip) {
          const { mapClip } = this.nowSeletedItem;
          let changed = false;
          if (event.keyCode === 81) {
            mapClip.angle -= 1;
            changed = true;
          } else if (event.keyCode === 69) {
            mapClip.angle += 1;
            changed = true;
          } else if (event.keyCode === 90) {
            mapClip.angle -= 0.1;
            changed = true;
          } else if (event.keyCode === 67) {
            mapClip.angle += 0.1;
            changed = true;
          }

          if (changed) {
            mapClip.SaveData();
            this.showSeleted(mapClip);
          }
        }
      },
      false
    );
    window.addEventListener(
      'keyup',
      (event) => {
        this.keyPress.downCode = 0;
      },
      false
    );

    document.getElementById('pixi').addEventListener(
      'mousewheel',
      (e) => {
        if (this.bgSprite === null) return;
        if (this.editPlaneVisible) return;
        // console.log(this.mousedata.over);
        if (e.wheelDelta > 0) {
          // this.bgSprite.scale.set(this.bgSprite.scale.x+0.1,this.bgSprite.scale.y+0.1)
          if (this.keyPress.downCode == 32) {
            this.allChangedScale(1.01);
          } else {
            this.mapCavans.scale.set(
              this.mapCavans.scale.x * 1.1,
              this.mapCavans.scale.y * 1.1
            );
          }

          //  this.bgSprite.scale.set(this.bgSprite.scale.x*1.1,this.bgSprite.scale.y*1.1);
          // this.mapCavans.scale.set(this.mapCavans.scale.x*1.1,this.mapCavans.scale.y*1.1);
        }
        if (e.wheelDelta < 0) {
          // this.bgSprite.scale.set(this.bgSprite.scale.x-0.1,this.bgSprite.scale.y-0.1)
          if (this.keyPress.downCode == 32) {
            this.allChangedScale(0.99);
          } else {
            this.mapCavans.scale.set(
              this.mapCavans.scale.x * 0.9,
              this.mapCavans.scale.y * 0.9
            );
          }
          //  this.bgSprite.scale.set(this.bgSprite.scale.x*0.9,this.bgSprite.scale.y*0.9);
          // this.mapCavans.scale.set(this.mapCavans.scale.x*0.9,this.mapCavans.scale.y*0.9);
        }
      },
      false
    );

    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    document.getElementById('pixi').removeEventListener(
      'mousewheel',
      () => { },
      false
    );
    window.removeEventListener('resize', this.onResize);
  }
};
</script>

<style lang="scss" scoped>
.map-main {
  width: 100%;
  overflow: hidden;
}

.mapplane {
  height: calc(100% - 50px);
  width: 100%;
  overflow: hidden;
}

.leftplane {
  flex: 1;
  height: 100%;
}

.left-menu {
  padding: 10px;
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
}

.toolbar {
  width: 80%;
  display: flex;
  height: 30px;
}

.helpbox {
  width: 20%;
  margin-right: 20px;
  text-align: end;
}

.tip {
  position: absolute;
  background: #fff;
  width: fit-content;
  height: fit-content;
  right: 305px;
  top: 120px;
}

.help {
  width: auto;
  text-align: end;
}

.blockbox {
  margin-left: 20px;
  display: inline-flex;
  width: 200px;
}

.block {
  width: 200px;
  z-index: 99999;
}

.stage {
  width: calc(100% - 300px);
  height: calc(100% - 65px);
  margin-top: 65px;
}

.right-title {
  height: 35px;
  font-weight: 50;
  padding-left: 80px;
  padding-top: 15px;
  font-size: 16px;
}

.borderline {
  width: 100%;
  height: 1px;
  border-top: solid #acc0d8 1px;
}

.right-plane {
  position: absolute;
  right: 0;
  top: 65px;
  width: 300px;
  height: calc(100% - 65px);
  background-color: #ffffff;
  z-index: 9999;
}

.right-list {
  width: 100%;
  height: calc(100% - 36px);
  overflow-x: hidden ;
}

.list {
  width: 100%;
  height: 90%;
  overflow-x: hidden;
}

.listbtn {
  margin-left: 10px;
}

.dragitem {
  margin-top: 5px;
  margin-bottom: 5px;
  height: 32px;
  border-radius: 4px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
  margin-inline: 10px;
  width: 100%;
}

.list-group-item {
  margin-top: 5px;
  margin-bottom: 5px;
  height: 30px;
  border-radius: 4px;
  border: solid #acc0d8 1px;
  padding: 5px;
  display: flex;
}

.list-group-item:hover {
  background-color: #dee2e7;
}

.list-group-item:hover .movetip {
  display: block;
}

.left-button {
  width: 100px;
  margin-left: 10px;
}

.list-group-item-selected {
  margin-top: 5px;
  color: white;
  margin-bottom: 5px;
  height: 30px;
  border-radius: 4px;
  border: solid #acc0d8 1px;
  padding: 5px;
  display: flex;
  background-color: #007aff;
}

.list-group-item-selected:hover .movetip {
  display: block;
}

.list-group-item i {
  cursor: pointer;
}

.itemrow {
  width: 90%;
  align-self: center;
  font-size: 12px;
}

.badge-green {
  background-color: #34c759;
  align-content: center;
  text-align: center;
  color: white;
  width: 10px;
  height: 10px;
  font: 12px/18px Arial, serif;
  border-radius: 5px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  box-shadow: 0 px 1px 0 px rgba(0, 0, 0, 0.3);
}

.proudceing {
  background: #acc0d8;
}

.badge {
  background-color: #e4e5e7;
  align-content: center;
  text-align: center;
  color: white;
  width: 10px;
  height: 10px;
  font: 12px/18px Arial, serif;
  border-radius: 5px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  box-shadow: 0 px 1px 0 px rgba(0, 0, 0, 0.3);
}

.right-bottom {
  margin-top: 10px;
  margin-bottom: 10px;
}

.elp {
  height: 100%;
  ::v-deep {
    .el-scrollbar__wrap {
      overflow-x: hidden !important;
      margin-bottom: 0 !important;
    }
    .el-scrollbar__bar.is-horizontal {
      display: none !important;
    }
  }
}

.is-horizontal {
  display: none;
}
.el-scrollbar__bar.is-vertical {
  width: 0 !important;
}

.dialog__footer {
  position: absolute;
  left: 30%;
}

.dialog__header {
  height: 50px;
  display: flex;
  align-items: center;
  margin-left: 20px;
  font-weight: 500;
  color: #6c6c6c;
}

.movetip {
  display: none;
  cursor: default;
  right: 5px;
  float: right;
  line-height: 0.3em;
}

#app{
  overflow: hidden;
}
</style>
